import { RType } from 'routes/types';

// Case-insensitive: route paths may be camelCase (e.g. `/courtDetails`).
const norm = (s: string) => s.toLowerCase();

/** The pathname is on this path, or on a page nested under it. */
export const matchesPath = (pathname: string, routePath: string): boolean => {
    const p = norm(pathname);
    const r = norm(routePath);
    return p.endsWith(r) || p.includes(r + '/');
};

/** Own path, or any of the route's declared `activePaths` (detail pages on sibling paths). */
export const matchesRoute = (pathname: string, route: RType): boolean =>
    matchesPath(pathname, route.path) ||
    (route.activePaths ?? []).some((p) => matchesPath(pathname, p));

/**
 * A route is highlighted only when it is the MOST SPECIFIC match. `/court-recording`
 * matched under `/court-recording/venue-agents` too (the nested-page rule above), so
 * both sidebar items lit up at once. A longer sibling route that starts with this
 * route's path and also matches wins; a parent still lights up for its own detail
 * pages (`/courts` under `/courtDetails`), which no sibling route claims.
 */
export const isRouteActive = (pathname: string, route: RType, routes: RType[]): boolean => {
    if (!matchesRoute(pathname, route)) return false;
    const own = norm(route.path);
    return !routes.some(
        (other) =>
            other !== route &&
            norm(other.path).length > own.length &&
            norm(other.path).startsWith(own) &&
            matchesRoute(pathname, other),
    );
};
